// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "client-portal-20190224164444-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2wf39l3x27sko.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:af38c2b6-30a7-41e4-82f1-92c2a3ce9bd3",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_srz5xmjEJ",
    "aws_user_pools_web_client_id": "58elho12blbs6j6ihbumf19onl",
    "aws_user_files_s3_bucket": "client-portalf975d1f4171345db9e5b9b7605c27aae-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ybljuslxvvcgjijztx4suxzmcu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
